export default __webpack_public_path__ + "static/media/back-to-top-icon.cc03c2ac.png";